import { useRef } from "react";

const useHoverLottie = ({ animationData }: { animationData: any }) => {
  const lottieRef = useRef<any>(null);
  const lottieOptions = useRef({
    loop: false,
    animationData,
    lottieRef,
  });
  const playLottieOnce = () => {
    if (lottieRef.current) {
      lottieRef.current.stop();
      lottieRef.current.setDirection(1);
      lottieRef.current.play();
    }
  };
  const stopLottie = () => {
    if (lottieRef.current) {
      lottieRef.current.setDirection(-1);
      lottieRef.current.play();
      // lottieRef.current.stop();
    }
  };
  return {
    lottieRef,
    playLottieOnce,
    stopLottie,
    lottieOptions: lottieOptions.current,
  };
};
export default useHoverLottie;
